export default __webpack_public_path__ + "static/media/Information.0e2557dc.svg";